import { Controller } from "stimulus";

// Collapsible alerts panel + jump-to-tab. The panel sits above the tabs on a
// staged clearance, so a Jump click has to switch tabs too (Bootstrap does not
// do that for a plain `#anchor` href).
export default class extends Controller {
  static targets = ["body", "chevron", "toggle"];

  toggle() {
    const hidden = this.bodyTarget.classList.toggle("d-none");
    this.chevronTarget.textContent = hidden ? "▸" : "▼";
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", (!hidden).toString());
    }
  }

  jump(event) {
    // The row is clickable in full, but the dismiss button sits inside it.
    // Bail if the click came from the button so dismiss doesn't also navigate.
    if (event.target.closest("form, button, a")) return;

    const anchor = event.currentTarget.dataset.anchor;
    if (!anchor) return;

    const tab = document.querySelector(`a[href="#${anchor}"][data-toggle="tab"]`);
    if (!tab) return;

    // Bootstrap 4's $(el).tab("show") is only reachable from the vendored
    // modules — jQuery is not on window. The DOM dance it performs is small
    // enough to do by hand: swap `active` on the links in the same tablist,
    // and `show active` on the panes they point to.
    const tabList = tab.closest('[role="tablist"]');
    tabList
      .querySelectorAll('[data-toggle="tab"]')
      .forEach((link) => link.classList.remove("active"));
    tab.classList.add("active");

    document
      .querySelectorAll(".tab-pane")
      .forEach((pane) => pane.classList.remove("show", "active"));
    const pane = document.querySelector(tab.getAttribute("href"));
    pane?.classList.add("show", "active");

    // Panel sits above the tabs and takes a lot of room on a messy clearance,
    // so switching the tab silently leaves the pane out of view. Scroll the
    // tablist to the top of the viewport so the activated pane is right there.
    tabList.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
